import Spinner from "@/components/atoms/Spinner/Spinner";
import Toolbar from "@/containers/Toolbar";
import { cn } from "@/lib/utils";
import { CustomizeRow } from "@/pages/Sbcs/SbcSetPage/components/CustomizeRow";
import GetCardSBC from "@/pages/Sbcs/SbcSetPage/components/GetCardSbc";
import { SbcSet } from "@/redux/sbcs/sbcSetsSlice";
import { Sbc } from "@/redux/sbcs/sbcsSlice";
import { ReactNode } from "react";

/**
 * The set page below its header, on every viewport. The parts are the same:
 * the set header, the Customize row, the challenges. Only the shell changes
 * with the screen.
 */
export const SbcSetView = ({
  sbcSet,
  setHeader,
  sbcs,
  isTouch,
}: {
  sbcSet?: SbcSet;
  setHeader: ReactNode;
  sbcs: Sbc[];
  isTouch: boolean;
}) => {
  return (
    <div className="flex w-full flex-col">
      <div
        className={cn(
          "mx-auto flex w-full max-w-content items-center",
          // Same inset as the toolbar and the challenges below it, so the
          // crest and the vote line up with the cards rather than the page.
          isTouch ? "px-4 py-2" : "mt-2 px-4 py-4 large:px-16",
          isTouch ? "min-h-40" : "min-h-[220px]",
        )}
      >
        <div className="flex-1">{sbcSet && setHeader}</div>
      </div>

      {/* The toolbar holds its height from the first paint, but waits for the
          set before filling. */}
      <Toolbar color="bg-surface">{sbcSet && <CustomizeRow />}</Toolbar>

      <div
        className={cn(
          "mx-auto w-full max-w-content p-4",
          !isTouch && "px-4 large:px-16",
        )}
      >
        {sbcs?.length > 0 ? (
          /* Challenges are scanned against each other, not read one by one, so
             they tile. Three up once there is room for three. */
          <div className="grid grid-cols-1 gap-4 desktop:grid-cols-2 touch-device:grid-cols-3">
            {sbcs.map((sbc) => (
              <GetCardSBC key={sbc.id} sbc={sbc} />
            ))}
          </div>
        ) : (
          <div className="m-auto">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
